export const UPDATE_ORDER_SUBSCRIPTION = "UPDATE_ORDER_SUBSCRIPTION";

export const handleUpdateOrderSubscription = (data) => {
  return {
    type: UPDATE_ORDER_SUBSCRIPTION,
    payload: data,
  };
};
